@if (verifyMAForm$ | async; as form) {
  <form
    [ngrxFormState]="form"
    (submit)="onSubmit(form)"
    >
    @if (loginResponse) {
      <div>
        <h3>Configura Microsoft Authenticator</h3>
        <p class="mt-2 mb-4">
          Scansiona il QR code con l'app Microsoft Authenticator.<br />
          Dopo aver configurato l'app, inserisci il codice di verifica generato per
          completare la configurazione della tua autenticazione a due fattori.<br />
          <strong>Attenzione!</strong> Se non configuri l'app Microsoft
          Authenticator, non potrai procedere con l'accesso.
        </p>
        @if (loginResponse.qrCodeImage) {
          <div class="mb-4">
            <img
              [src]="loginResponse.qrCodeImage"
              alt="QR Code per 2FA"
              style="display: block"
              class="border p-1 rounded-md mx-auto"
              />
          </div>
        }
        <h3>
          Inserisci il codice di verifica generato dall'app Microsoft Authenticator.
        </h3>
        <div class="mb-3 mt-3">
          <ideapa-otp-field
            [label]="'Codice di verifica'"
            [ngrxFormControlState]="form.controls.otpCode"
            [errors]="form.controls.otpCode.errors | ngrxFormsErr"
            [shouldShowError]="form.controls.otpCode.isInvalid && form.controls.otpCode.isSubmitted"
          ></ideapa-otp-field>
        </div>
        <div class="mt-3 text-end">
          <!-- <ideapa-button
          id="button-login"
          type="submit"
          [cssClasses]="'btn-primary'"
          [text]="'Prosegui'"
          (clicked)="proceed()"
        ></ideapa-button> -->
        <ideapa-button
          type="submit"
          [cssClasses]="'btn-primary'"
          [text]="'Accedi'"
        ></ideapa-button>
      </div>
    </div>
  }
</form>
}
